module.exports = __webpack_public_path__ + "img/announcement_2024_11_01_2.4bb2cf66.jpg";